import router from '@router';
import http from './http.service';
import {vm} from '@main';

class AuthService {
    constructor() {
        if (AuthService.instance) {
            return AuthService.instance;
        }

        this._isAuthorized = !!localStorage.getItem('authentication');

        AuthService.instance = this;
    }


    get isAuthorized() {
        return this._isAuthorized;
    }

    // async checkAuth() {
    //
    //     let promise = new Promise((resolve, reject) => {
    //         setTimeout(() => resolve("done!"), 1000)
    //     });
    //
    //     let result = await promise; // wait until the promise resolves (*)
    //
    //     alert(result); // "done!"
    // }

    login(data) {
        return http.post('/login', data).then(res => {
            if (res) {
                this._isAuthorized = true;
                localStorage.setItem('authentication', 'done');

                router.push('/auth/dashboard');
            } else {
                throw new Error('Something went wrong can\'t find res for /oauth/token request');
            }
        });
    }

    logout() {
        if (!this._isAuthorized || !localStorage.getItem('authentication')) {
            return;
        }

        this._isAuthorized = false;

        return http.get('/logout').then(res => console.log(res.data))
            .catch(() => console.error('Already logged out'))
            .finally(() => {
                localStorage.clear();
                router.push('/auth/login');
            });
    }

    register(data) {
        return http.post('/register', data).then(res => {
            // vm.$toastr.s(res.data.message);
            if (res) {
                router.push('/auth/login');
            } else {
                console.log(res);
                throw new Error('Something went wrong can\'t find res for /oauth/token request');
            }
        });
    }
}

export default new AuthService();
